import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
const steps = [{
  time: '1-2 min',
  label: 'Preparación y Seguridad'
}, {
  time: '3-5 min',
  label: 'Inmersión de Choque'
}, {
  time: '6-8 min',
  label: 'Activación de Flujo'
}, {
  time: '9-11 min',
  label: 'Repetición de Cierre'
}, {
  time: '12 min',
  label: 'Secado y Elevación'
}];
export function ProtocolTeaser() {
  return <section className="py-20 lg:py-28 bg-white" data-id="element-133">
      <div className="max-w-4xl mx-auto px-5 sm:px-8" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-14" data-id="element-135">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-charcoal mb-3" data-id="element-136">
            El Protocolo SOS de 12 Minutos
          </h2>
          <p className="text-xl sm:text-2xl font-heading text-emerald-brand font-semibold" data-id="element-137">
            Tu Primer Paso Esta Noche
          </p>
        </motion.div>

        <div className="relative max-w-lg mx-auto" data-id="element-138">
          {/* Vertical connector */}
          <div className="absolute left-6 top-4 bottom-4 w-0.5 bg-emerald-light rounded-full" data-id="element-139" />

          <div className="space-y-6" data-id="element-140">
            {steps.map((s, i) => <motion.div key={i} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="flex items-center gap-5 relative" data-id="element-141">
                <div className="w-12 h-12 rounded-full bg-emerald-brand text-white flex items-center justify-center font-heading font-bold text-lg flex-shrink-0 z-10 shadow-md" data-id="element-142">
                  {i + 1}
                </div>
                <div className="bg-cream rounded-xl p-4 sm:p-5 flex-1 border border-emerald-brand/10" data-id="element-143">
                  <span className="text-sm font-bold text-gold-brand font-body uppercase tracking-wide" data-id="element-144">
                    {s.time}
                  </span>
                  <p className="text-lg sm:text-xl font-heading font-semibold text-charcoal mt-0.5" data-id="element-145">
                    {s.label}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-14 text-center bg-emerald-light rounded-2xl p-8 border border-emerald-brand/15" data-id="element-146">
          <p className="text-lg sm:text-xl font-body text-charcoal mb-7 leading-relaxed" data-id="element-147">
            Dentro del libro encontrarás las instrucciones exactas, temperaturas
            precisas para evitar quemaduras, y la ciencia detrás de cada paso.
          </p>
          <a href="#pricing" className="inline-flex items-center justify-center gap-3 bg-emerald-brand hover:bg-emerald-dark text-white font-bold text-lg sm:text-xl py-4 px-8 rounded-xl shadow-lg transition-all hover:scale-105" data-id="element-148">
            ¡Quiero Aprender el Protocolo Completo!
            <ArrowDownIcon className="w-5 h-5" data-id="element-149" />
          </a>
        </motion.div>
      </div>
    </section>;
}